import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';

/** Closing route into the associated Government solution and its workspace demo. */
export function CognocracyClosing() {
  return <section aria-labelledby="cognocracy-government" className="bg-navy text-white py-20 lg:py-28" data-id="element-218" data-mp="5kr6ao06do8y">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end" data-id="element-219" data-mp="m644j1d4uhv">
        <div className="lg:col-span-7" data-id="element-220" data-mp="tdzie4xv35wf">
          <p className="text-sm font-medium text-teal mb-3" data-id="element-221" data-mp="odlbiq7zy1zz">Government solution</p>
          <h2 id="cognocracy-government" className="font-heading font-bold text-3xl lg:text-4xl tracking-tight leading-tight" data-id="element-222" data-mp="ofoa3yn7t3gb">
            See Cognocracy’s ideas in a working workspace.
          </h2>
          <p className="mt-5 text-lg text-white/80 leading-relaxed" data-id="element-223" data-mp="3447vgbmfoxyf">
            NCDS is the government solution associated with Cognocracy. Explore how it connects citizen development and
            institutional coordination, then try the Government workspace demonstration.
          </p>
        </div>
        <div className="lg:col-span-5 lg:justify-self-end" data-id="element-224" data-mp="166gkel5nwnzz">
          <a href="/government" className="inline-flex items-center justify-center gap-2 bg-white text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-225" data-mp="1681hoijd2l1j">
            See the government solution <ArrowRight size={18} aria-hidden="true" data-id="element-226" data-mp="nha7xfvgosmm" />
          </a>
        </div>
      </motion.div>
    </section>;
}